import dayjs from 'dayjs'
// 获取环境变量（在代码中直接使用）
export const getEnv = (key: string, defaultValue = '') => {
  return import.meta.env[key] || defaultValue
}

// 环境判断函数
export const isDevelopment = () => import.meta.env.MODE === 'development'
export const isProduction = () => import.meta.env.MODE === 'production'
export const isTest = () => import.meta.env.MODE === 'test'

// 获取API基础URL
export const getChatApiBaseUrl = () => {
  return getEnv('VITE_CHAT_API_BASE_URL', '')
}

export const parseCookies = () => {
  const cookies = document.cookie.split('; ');
  const cookieObj: { [key: string]: string } = {};
  console.log('解析cookie', cookies)
  cookies.forEach(cookie => {
    const [name, value] = cookie.split('=');
    console.log('for循环', name, cookie)
    cookieObj[name] = value;
  });
  return cookieObj;
};

export const formatChatDate = (dateStr: string | number): string => {
  const date = dayjs(dateStr);
  const now = dayjs();
  const today = now.startOf('day');
  const thisYear = now.year();
  const year = date.year();
  const month = date.month() + 1; // Day.js 中月份从0开始计数
  const dayOfMonth = date.date();
  const hours = date.hour();
  const minutes = date.minute();

  // 格式化月份和日期，确保为两位数
  const monthStr = month.toString().padStart(2, '0');
  const dayOfMonthStr = dayOfMonth.toString().padStart(2, '0');
  const hoursStr = hours.toString().padStart(2, '0');
  const minutesStr = minutes.toString().padStart(2, '0');

  if (year === thisYear && month === today.month() + 1 && dayOfMonth === today.date()) {
    // 如果是今天，则只显示小时和分钟
    return `${hoursStr}:${minutesStr}`;
  } else if (year === thisYear) {
    // 如果是今年但不是今天，则显示月-日
    return `${monthStr}-${dayOfMonthStr}`;
  } else {
    // 否则显示年-月-日
    return `${year}-${monthStr}-${dayOfMonthStr}`;
  }
}

export const jsonToCookies = (json: { [key: string]: string }) => {
  let cookies = '';
  Object.keys(json).forEach(key => {
    cookies += `${key}=${json[key]}; path=/`;
  });
  return cookies;
};

export class SessionStorageManager {
  // 获取数据
  get(key: string): any {
    const data = localStorage.getItem(key);
    let res = null
    try {
      res = data ? JSON.parse(data) : null;
    } catch(e) {
      console.error(e)
    }
    return res;
  }
  
  // 保存数据
  set(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }
  
  // 删除数据
  remove(key: string): void {
    localStorage.removeItem(key);
  }
  
  // 清空所有数据
  clear(): void {
    localStorage.clear();
  }
  
  // 获取token
  getToken(): string | null {
    return this.get('token');
  }
  
  // 设置token
  setToken(token: string): void {
    this.set('token', token);
  }
  
  // 删除token
  removeToken(): void {
    this.remove('token');
  }
}

// 基础防抖函数
export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null
  
  return (...args: Parameters<T>) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    
    timeoutId = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}

// 创建一个单例实例
export const sessionStorageManager = new SessionStorageManager();